var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreeArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84467 6.84467C8.55178 7.13756 8.55178 7.61244 8.84467 7.90533L13.5643 12.625L8.84467 17.3447C8.55178 17.6376 8.55178 18.1124 8.84467 18.4053C9.13756 18.6982 9.61244 18.6982 9.90533 18.4053L15.1553 13.1553C15.4482 12.8624 15.4482 12.3876 15.1553 12.0947L9.90533 6.84467C9.61244 6.55178 9.13756 6.55178 8.84467 6.84467Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeArrowRight);
export default __webpack_public_path__ + "static/media/icon-tree-arrow-right.18ce813e8def2ac815a59bcb0d6babd0.svg";
export { ForwardRef as ReactComponent };